import { signInWithRedirect } from 'aws-amplify/auth';
import { useState } from 'react';
import { useSearchParams } from 'react-router';

import { Input } from '@/components/form/Input';
import { Button } from '@/components/ui/button';
import { Disclaimer } from '@/sections/signup/Disclaimer';
import { PageWrapper } from '@/sections/signup/PageWrapper';
import { validateRedirectUrl } from '@/utils/redirect.util';

export const LoginSSO = () => {
  const [username, setUsername] = useState<string>('');
  const [searchParams] = useSearchParams();

  const handleSignin = async () => {
    // SECURITY: Validate redirect before storing to prevent open redirect (CWE-601)
    // Defense in depth - validate at storage AND retrieval
    const redirect = searchParams.get('redirect');
    const validatedRedirect = validateRedirectUrl(redirect);

    // Only store if validated to a non-default value
    if (validatedRedirect !== '/') {
      sessionStorage.setItem('oauth_redirect_url', validatedRedirect);
    }

    await signInWithRedirect({
      provider: {
        custom: username.split('@')[1],
      },
    });
  };

  return (
    <PageWrapper title="Sign in with SSO" showBack={true}>
      <form
        className="flex flex-1 flex-col gap-4 space-y-4 p-2"
        id="signup"
        onSubmit={e => {
          e.preventDefault();
          handleSignin();
        }}
      >
        <Input
          label={'Email Address'}
          value={username}
          placeholder={'victoria@praetorian.com'}
          name={'username'}
          required={true}
          onChange={e => {
            setUsername(e.target.value);
          }}
        />
        <Button className="w-full" type="submit" id="signup">
          Continue
        </Button>
        <Disclaimer />
      </form>
    </PageWrapper>
  );
};
